// extracted by mini-css-extract-plugin
export var closeButton = "_1b-1";
export var container = "_1b-0";
export var fullModalImage = "_1b-2";